import script from "./ModalMinCollateral.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalMinCollateral.vue?vue&type=script&setup=true&lang=js"

import "./ModalMinCollateral.vue?vue&type=style&index=0&id=3b545632&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b545632"]])

export default __exports__